import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import xhr from 'xhr';
import { CSRF_TOKEN } from 'constants';

class SSA extends React.Component {
  static propTypes = {
    ssaUrl: PropTypes.string.isRequired,
    returnToUrl: PropTypes.string,
    buttonText: PropTypes.string
  }

  state = {
    canContinue: false,
    buttonText: this.props.buttonText,
    errorMessage: ''
  }

  onChange = (e) => {
    this.setState({ canContinue: e.target.checked });
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.setState({ buttonText: 'Saving...' }, () => {
      xhr('/ssa-acceptance.json', {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': CSRF_TOKEN
        },
        method: 'POST',
        onSuccess: () => {
          this.setState({ buttonText: 'Saved!', errorMessage: null });
          window.location = this.props.returnToUrl;
        },
        onError: () => {
          this.setState({
            buttonText: this.props.buttonText,
            errorMessage: 'Sorry, there was an error accepting the SSA. Contact technicalsupport@solarwinds.com if this persists.'
          });
        }
      });
    });
  }

  render() {
    const { ssaUrl, ssaEmbedUrl } = this.props;

    return (
      <div className="ssa-acceptance">
        <h1>
          <img src="/images/flame-white.svg" /> Updated Software Services Agreement
        </h1>

        <p className="copy">
          We have updated our <a href={ssaUrl} target="_blank">Software Services Agreement</a> to better document how
          we work with our customers. Please read and accept the updated version to continue:
        </p>

        <p className="ssa-acknowledge">
          <label>
            <input type="checkbox" onChange={this.onChange} />
            I agree to the <a href={ssaUrl} target="_blank">Software Services Agreement</a>
          </label>
        </p>

        <p className="submission">
          <span className="error">{this.state.errorMessage}</span>

          <button
            className="btn"
            disabled={!this.state.canContinue}
            onClick={this.onSubmit}
          >
            {this.state.buttonText}
          </button>
        </p>
      </div>
    );
  }
}

ReactDOM.render(
  <SSA
    ssaUrl="/info/terms"
    returnToUrl={PT.SSA.returnToUrl}
    buttonText="Continue"
  />,
  document.getElementById('ssa-acceptance')
);

export default SSA;
